<template>
	<j-card class="p2 mb2 flex xs-middle xs-between bg5">
		<div class="fs3 fw7">
			{{ $t("shared_with_case_creator", { caseCreator }) }}
		</div>
		<j-base-toggle
			v-if="shared !== null"
			size="small"
			:value="shared"
			@input="onInputShared"
		/>
	</j-card>
</template>

<script>
import JBaseToggle from "@/components/JBaseToggle/"
import JCard from "@/components/JCard"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	props: {
		policyId: String
	},

	components: { JBaseToggle, JCard },

	data() {
		return {
			shared: null,
			caseCreator: "---",
			createdById: null,
			permission: null
		}
	},

	methods: {
		async fetchCreator() {
			const query = gql`
				query fetchCreator($where: policyWhereInput) {
					policies(where: $where) {
						list {
							proposal {
								case {
									createdBy {
										id
										username
										targettedPermissions {
											permission {
												id
											}
											targetIds
										}
									}
								}
							}
						}
					}
				}
			`
			const variables = {
				where: { id: this.policyId }
			}
			const res = await api({ query, variables })
			this.caseCreator =
				res?.data?.policies.list[0]?.proposal?.case?.createdBy?.username
			this.createdById =
				res?.data?.policies.list[0]?.proposal?.case?.createdBy?.id
			this.permission = res?.data?.policies.list[0]?.proposal?.case?.createdBy?.targettedPermissions?.find(
				tp => tp.permission.id === "readPolicies"
			)
			this.shared = Boolean(this.permission?.targetIds?.includes(this.policyId))
		},

		async onInputShared(payload) {
			if (payload) {
				// Add targetted permission
				const query = gql`
					mutation addTargettedPermission(
						$loginId: String!
						$input: addTargettedPermissionInput!
					) {
						addTargettedPermission(
							loginId: $loginId
							addTargettedPermissionInput: $input
						) {
							errors
							status
						}
					}
				`
				const variables = {
					loginId: this.createdById,
					input: {
						type: "readPolicies",
						value: this.policyId
					}
				}
				const res = await api({ query, variables })
				// Errors
				if (res?.data?.addTargettedPermission?.status !== "success") {
					this.$store.dispatch(
						"showError",
						res?.data?.addTargettedPermission?.errors?.[0] ||
							this.$t("errors.general")
					)
					return
				}
			} else {
				// Remove targetted permission
				const query = gql`
					mutation removeTargettedPermission(
						$loginId: String!
						$type: String!
						$value: String!
					) {
						removeTargettedPermission(
							loginId: $loginId
							type: $type
							value: $value
						) {
							errors
							status
						}
					}
				`
				const variables = {
					loginId: this.createdById,
					type: "readPolicies",
					value: this.policyId
				}
				const res = await api({ query, variables })
				// Errors
				if (res?.data?.removeTargettedPermission?.status !== "success") {
					this.$store.dispatch(
						"showError",
						res?.data?.removeTargettedPermission?.errors?.[0] ||
							this.$t("errors.general")
					)
					return
				}
			}
			this.fetchCreator()
		}
	},

	created() {
		this.fetchCreator()
	}
}
</script>
